<template>
  <div class="padding-10">
    <v-btn tile color="info" @click="refreshPage" style="margin-bottom: 10px;">
      <v-icon left>mdi-refresh</v-icon>
      <slot>Clear Form</slot>
    </v-btn>
    
    <v-card class="white-background padding-5" :elevation="$root.ele">
      <v-form v-if="!isLoading" v-model="isValid" ref="form">
        <!-- <p v-if="item.uploads">{{ present }}</p> -->
        
        <job-details
          :item="item"
          ref="toolbar"
          :isAutoJob="isAutoJob"
          v-model="toolbar"
          @emptyJobDetails="emptyJobDetails"
          :total="total"
        ></job-details>
        
        <Form
          @onAPTSelected="$refs.toolbar.openAPT()"
          :item="item"
          :toolbar="toolbar"
          :template="template"
          @autoJob="isAutoJob = true"
          v-model="form"
          ref="formComponent"
        ></Form>
        
        <unknown-fields :item="item"></unknown-fields>
        
        <!-- ✅ CHANGED: Use EstimateFooter instead of CustomerFooter/JobFooter -->
        <estimate-footer
          :item="item"
          @addRecord="addRecord($event)"
          @updateEstimate="updateEstimate"
        ></estimate-footer>
      </v-form>
    </v-card>
    
    <complete
      :item="item"
      :form="toolbar"
      :disposition_date="disposition_date"
      v-if="complete"
      @close="complete = false"
    ></complete>
  </div>
</template>

<script>
import {
  getDate,
  getDateOnly,
  getNormalDateTime,
} from "../../assets/js/common";
import {
  getCommonField,
  getCreditCardCharges,
  getOptionValue,
} from "../../assets/js/customer.helper";
import customerMixins from "../../assets/js/customer.mixins";
import customerModal from "../../assets/js/customer.modal";
import { auth,
  //  customers, 
    functions,
    estimate } from "../../assets/js/firebase";
import Complete from "../jobs/Complete.vue";
import Form from "./create/Form.vue";
import JobDetails from "./create/JobDetails.vue";
import UnknownFields from "./create/UnknownFields.vue";
import EstimateFooter from "./create/EstimateFooter.vue"; // ✅ CHANGED: Import EstimateFooter
import { EventBus } from "../../main";

export default {
  components: {
    JobDetails,
    Form,
    EstimateFooter, // ✅ CHANGED: Use EstimateFooter
    Complete,
    UnknownFields,
  },
  mixins: [customerMixins],
  data() {
    return {
      isUploadImg: false,
      isValid: false,
      isLoading: false, 
      isAutoJob: false,
      item: {},
      form: {},
      complete: false,
      disposition_date: "",
      toolbar: {
        template: "",
        technician: "",
        is_scheduled: false,
        scheduled_at: "",
        disposition: "",
        schedule_end_at: "",
        disposition_date: "",
        dispatcher: "",
        created_at: getDateOnly(),
        status: 0,
        vin_number: "",
        reason: "",
        technician_total_collected: "",
      },
      unsubscribe: null,
    };
  },
  computed: {
    total() {
      return this.form[customerModal.TOTAL] || 0;
    },
    template() {
      let template = this.jobTemplates.find((item) => {
        return item.id == this.toolbar.template;
      });
      return template || {};
    },
    // ✅ CHANGED: Force isCreate and isCustomer for estimates
    isCreate() {
      return this.$route.name === 'estimate-create' || !this.$route.params.id;
    },
    isCustomer() {
      return true; // Always true for estimates
    },
    isFormFieldChanged() {
      const vm = this;
      let changed = false;
      Object.keys(vm.toolbar).forEach((key) => {
        if (key == "reason") {
          if (
            vm.toolbar[key] !=
            vm.item.fields?.[customerModal.REASON_FOR_CANCELLATION]
          ) {
            changed = true;
          }
        } else if (vm.toolbar[key] != vm.item[key]) {
          changed = true;
        }
      });
      Object.keys(vm.item.fields || {}).forEach((key) => {
        let excludeKeys = ["Phone", customerModal.REASON_FOR_CANCELLATION];
        if (
          vm.form[key] != vm.item.fields[key] &&
          excludeKeys.indexOf(key) == -1
        ) {
          changed = true;
        }
      });
      return changed;
    },
    isETA() {
      let ETA = this.form[customerModal.ETA];
      let isETA = true;
      if (ETA) {
        isETA = ETA.toString().toLowerCase() == "appointment";
      }
      return isETA;
    },
    isAppointment() {
      const vm = this;
      let isAppointment = false;
      let { is_scheduled, scheduled_at } = vm.toolbar;
      let eta = vm.form[customerModal.ETA];
      if (eta) {
        isAppointment = eta.toString().toLowerCase() == "appointment";
      }
      return isAppointment && (is_scheduled != true || scheduled_at == "");
    },
  },
  beforeDestroy() {
    const vm = this;
    vm.$root.loading = false;
    if (vm.unsubscribe != null) vm.unsubscribe();
  },
  methods: {
    clearJobDetails() {
      this.emptyJobDetails();
    },
    onComplete(date) {
      this.complete = true;
      this.disposition_date = date;
    },
    
    getCountryCode(){
      return this.countryCode;
    },
    
    async addRecord(isSendSMS) {
      try {
        
        console.log('isSendsms ',isSendSMS)
        const vm = this;
        // temporarly removed the validation, add it later
        vm.$refs.form.validate();
        // console.log('validate: ',vm.$refs.form.validate())
        const customValidation = vm.$refs.formComponent.validateRequiredFields();
        // console.log('validate: ',customValidation)
        if (!customValidation.isValid) {
          return;
        }
        // // this is the code for the quote number, will uncomment later when backend is hosted
        const getQuoteNum = functions.httpsCallable("getQuoteNumber");
        const {data : quoteNumber} = await getQuoteNum();
        let doc = vm.getDoc();
        doc.quote_number = quoteNumber;

        if (vm.isAppointment) {
          vm.$alert.show("Please provide the appointment date and time.");
          return;
        }
        vm.$confirm.show({
          message: "Are you sure you want to save this estimate?",
          onConfirm: async () => {
            try {
              vm.$loader.show();
              const estimateDoc = await estimate.add(doc);
              console.log('Estimate created with ID:', estimateDoc.id);
              vm.$loader.hide();
              vm.$alert.show("Estimate saved successfully !");
              vm.$router.replace("/manage-estimate");
            } catch (error) {
              vm.$loader.hide();
              vm.$alert.show(error.message);
              console.error('Error creating estimate:', error);
            }
          },
        });
      } catch (error) {
        console.log(error)
      }
    },

    async updateEstimate() {
      const vm = this;
      vm.$refs.form.validate();

      const customValidation = vm.$refs.formComponent.validateRequiredFields();
      
      if ( !customValidation.isValid) {
        return;
      }
      
      if (!vm.isFormFieldChanged) {
        return vm.$alert.show("There is nothing to update");
      }
      if (vm.isAppointment) {
        vm.$alert.show("Please provide the appointment date and time.");
        return;
      }
      
      try {
        vm.$loader.show();
        let doc = vm.getDoc();
        let { id } = vm.$route.params;
        
        await estimate.doc(id).update(doc);
        vm.$loader.hide();
        vm.$alert.show("Estimate updated successfully!");
      } catch (error) {
        vm.$alert.show(error.message);
        vm.$loader.hide();
      }
    },

    init() {
      const vm = this;
      let { params } = vm.$route;
      if (vm.isCreate) {
        vm.isLoading = false;
        return;
      }
      let { id } = params;
      if (!id) {
        vm.$alert.show("No estimate ID provided");
        vm.$router.replace("/");
        return;
      }
      
      vm.$root.loader = true;
      try {
        vm.unsubscribe = estimate.doc(id).onSnapshot(
          (snap) => {
            vm.$root.loader = false;
            if (snap.exists) {
              vm.isLoading = true;
              let doc = snap.data();
              doc.id = snap.id;
              vm.item = doc;
              Object.keys(vm.toolbar).forEach((key) => {
                let val = doc[key];
                if (val != undefined) vm.toolbar[key] = val;
              });
              vm.toolbar.reason =
                doc.fields?.[customerModal.REASON_FOR_CANCELLATION] || "";
              vm.isLoading = false;
            } else {
              vm.$alert.show("Estimate not found");
              vm.$router.replace("/");
            }
          },
          (error) => {
            vm.$root.loader = false;
            vm.$alert.show(error.message);
          }
        );
      } catch (error) {
        vm.$root.loader = false;
        vm.$alert.show(error.message);
      }
    },
    
    getDoc() {
      const vm = this;
      let { form, toolbar, template, item } = vm;
      let { phone, name } = getCommonField(form);
      let email = auth.currentUser.email;
      let doc = {};
      Object.keys(toolbar).forEach((key) => {
        doc[key] = toolbar[key];
      });
      delete doc.reason;
      doc.fields = form;
      doc.fields[customerModal.REASON_FOR_CANCELLATION] = toolbar.reason || "";
      doc.options = getOptionValue(vm, vm.form);
      doc.updated_by = email;
      doc.name = name;
      doc.name_lower = name.toLowerCase();
      doc.charges = getCreditCardCharges(vm.form, vm);
      doc.created_at = getNormalDateTime(doc.created_at);
      if (doc.disposition_date) {
        doc.disposition_date = getNormalDateTime(doc.disposition_date);
      }
      doc.fields.Phone = phone;
      doc.updated_at = getDate();
      
      if (vm.isCreate) {
        doc.sms = "i";
        doc.template_name = template.name;
        doc.message = template.message;
        doc.reimbusements = 0;
        doc.is_agree = false;
        if (vm.isETA) doc.status = 4;
        
        doc.estimate_type = true;
        doc.phone_last5 = (phone || "").replace(/\D/g, "").slice(-5);
      } else {
        if (item.status == 1 && doc.technician) {
          doc.status = 2;
        }
        doc.estimate_type = true;
        doc.phone_last5 = (phone || "").replace(/\D/g, "").slice(-5);
      }
      
      Object.keys(doc).forEach((key) => {
        if (doc[key] == undefined) {
          doc[key] = "";
        }
      });
      return doc;
    },
    
    refreshPage() {
      EventBus.$emit("emptyJobDetails")
      this.emptyJobDetails();
    }, 
    emptyJobDetails() {
      this.isValid = false;
      this.isAutoJob = false;
      this.item = {};
      this.form = {};
      this.complete = false;
      this.toolbar = {
        template: "",
        technician: "",
        is_scheduled: false,
        scheduled_at: "",
        disposition: "",
        schedule_end_at: "",
        disposition_date: "",
        dispatcher: "",
        created_at: getDateOnly(),
        status: 0,
        vin_number: "",
        reason: "",
        technician_total_collected: "",      
      };
      if (typeof this.unsubscribe === 'function') {
        this.unsubscribe();
        this.unsubscribe = null;
      }
    },
    changeImgStatus() {
      this.isUploadImg = true;
    },
    changeCashStatus() {
      this.isFormFieldChanged = true;
    },
    setUploadsData(data) {
      this.item.uploads = data;
    },
  },
  mounted() {
    // Only call init() if NOT create mode AND id param exists
    if (!this.isCreate && this.$route.params && this.$route.params.id) {
      this.init();
    }
    EventBus.$on("changeImgStatus", this.changeImgStatus);
    EventBus.$on("changeCashStatus", this.changeCashStatus);
    EventBus.$on("getFiles", this.setUploadsData);
    console.log('Estimate module loaded');
  },
};
</script>

<style></style>
